var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.forgotPassword,
            expression: "!forgotPassword"
          }
        ],
        ref: "loginForm",
        staticClass: "sign-in",
        attrs: { tag: "form", novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onLogin.apply(null, arguments)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var errors = ref.errors
              return [
                !_vm.hideTitle
                  ? _c("h2", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("login.loginTitle"))
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.loginResponse.message
                  ? _c("GeneralMessage", {
                      attrs: {
                        message: _vm.loginResponse.message,
                        type: _vm.loginResponse.type
                      },
                      on: {
                        close: function($event) {
                          _vm.loginResponse.message = ""
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("ValidationProvider", {
                  ref: "loginEmail",
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "email",
                    rules: "required|email",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      email: _vm.$t("forms.errors.emailInvalid")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "email",
                                name: "email",
                                autocomplete: "email",
                                placeholder: _vm.$t("forms.labels.email"),
                                label: _vm.$t("forms.labels.email"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.loginForm.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.loginForm, "email", $$v)
                                },
                                expression: "loginForm.email"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "password",
                    rules: "required",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "password",
                                name: "password",
                                autocomplete: "current-password",
                                placeholder: _vm.$t("forms.labels.password"),
                                label: _vm.$t("forms.labels.password"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.loginForm.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.loginForm, "password", $$v)
                                },
                                expression: "loginForm.password"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "button",
                    level: "tertiary",
                    text: _vm.$t("login.forgotPasswordButton"),
                    disabled: _vm.disabled,
                    arrow: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.toggleForgotPassword(true)
                    }
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "submit",
                    level: "primary",
                    text: _vm.$t("login.loginButton"),
                    disabled: _vm.disabled
                  }
                })
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("ValidationObserver", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.forgotPassword,
            expression: "forgotPassword"
          }
        ],
        ref: "resetForm",
        staticClass: "sign-in",
        attrs: { tag: "form", novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onResetPassword.apply(null, arguments)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var errors = ref.errors
              return [
                !_vm.hideTitle
                  ? _c("h2", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("login.forgotPasswordTitle"))
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.resetResponse.message
                  ? _c("GeneralMessage", {
                      attrs: {
                        message: _vm.resetResponse.message,
                        type: _vm.resetResponse.type
                      },
                      on: {
                        close: function($event) {
                          _vm.resetResponse.message = ""
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("ValidationProvider", {
                  ref: "loginEmail",
                  staticClass: "input-wrapper",
                  attrs: {
                    name: "email",
                    rules: "required|email",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      email: _vm.$t("forms.errors.emailInvalid")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "email",
                                name: "email",
                                autocomplete: "email",
                                placeholder: _vm.$t("forms.labels.email"),
                                label: _vm.$t("forms.labels.email"),
                                error: invalid && validated,
                                disabled: _vm.disabled,
                                required: ""
                              },
                              model: {
                                value: _vm.loginForm.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.loginForm, "email", $$v)
                                },
                                expression: "loginForm.email"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "button",
                    level: "tertiary",
                    text: _vm.$t("login.rememberPasswordButton"),
                    disabled: _vm.disabled,
                    arrow: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.toggleForgotPassword(false)
                    }
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "submit",
                    level: "primary",
                    text: _vm.$t("login.resetPasswordButton"),
                    disabled: _vm.disabled
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }